export enum AuthenticationState {
    NotLoggedIn,
    Processing,
    SystemDown,
    Unauthorized,
    InvalidPassword,
    LoggedIn,
    SessionTimeout,
}
